/*eslint-v9-flat-configs*/
/*about-the-configuration-package*/
/*using-the-configuration-package*/
/*eslint-v8-legacy*/
/*the-repoeslint-config-package*/
/*how-to-use-the-repoeslint-config-package*/
/*setting-up-a-lint-task*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "ESLint",
  "description": "学习如何在 monorepo 中使用 ESLint。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "ESLint 是一个静态分析工具，用于快速查找和修复 JavaScript 代码中的问题。"
  }, {
    "heading": "",
    "content": "¥ESLint is a static analysis tool for quickly finding and fixing problems in your JavaScript code."
  }, {
    "heading": "",
    "content": "在本指南中，我们将介绍："
  }, {
    "heading": "",
    "content": "¥In this guide, we'll cover:"
  }, {
    "heading": "",
    "content": "使用扁平配置的 ESLint v9"
  }, {
    "heading": "",
    "content": "¥ESLint v9 with Flat Configuration"
  }, {
    "heading": "",
    "content": "使用旧配置的 ESLint v8"
  }, {
    "heading": "",
    "content": "¥ESLint v8 with legacy configuration"
  }, {
    "heading": "",
    "content": "如何设置 lint 任务（适用于两个版本）"
  }, {
    "heading": "",
    "content": "¥How to set up a lint task (applies to both versions)"
  }, {
    "heading": "",
    "content": "我们将在 monorepo 的工作区内共享配置，确保配置在各个包之间保持一致且可组合，以保持较高的缓存命中率。"
  }, {
    "heading": "",
    "content": "¥We will share configurations across the monorepo's Workspace, ensuring configuration is consistent across packages and composable to maintain high cache hit ratios."
  }, {
    "heading": "eslint-v9扁平配置-eslint-v9-flat-configs",
    "content": "¥ESLint v9 (Flat Configs)"
  }, {
    "heading": "eslint-v9扁平配置-eslint-v9-flat-configs",
    "content": "使用 ESLint v9 的 Flat Configs，我们最终会得到如下文件结构："
  }, {
    "heading": "eslint-v9扁平配置-eslint-v9-flat-configs",
    "content": "¥Using ESLint v9's Flat Configs, we will end up with a file structure like this:"
  }, {
    "heading": "eslint-v9扁平配置-eslint-v9-flat-configs",
    "content": "此结构包含："
  }, {
    "heading": "eslint-v9扁平配置-eslint-v9-flat-configs",
    "content": "¥This structure includes:"
  }, {
    "heading": "eslint-v9扁平配置-eslint-v9-flat-configs",
    "content": "./packages/eslint-config 中名为 @repo/eslint-config 的包，其中包含所有 ESLint 配置"
  }, {
    "heading": "eslint-v9扁平配置-eslint-v9-flat-configs",
    "content": "¥A package called @repo/eslint-config in ./packages/eslint-config that holds all ESLint configuration"
  }, {
    "heading": "eslint-v9扁平配置-eslint-v9-flat-configs",
    "content": "两个应用，每个都有自己的 eslint.config.js"
  }, {
    "heading": "eslint-v9扁平配置-eslint-v9-flat-configs",
    "content": "¥Two applications, each with their own eslint.config.js"
  }, {
    "heading": "eslint-v9扁平配置-eslint-v9-flat-configs",
    "content": "一个 ui 包，它本身也包含 eslint.config.js。"
  }, {
    "heading": "eslint-v9扁平配置-eslint-v9-flat-configs",
    "content": "¥A ui package that also has its own eslint.config.js"
  }, {
    "heading": "关于配置包-about-the-configuration-package",
    "content": "¥About the configuration package"
  }, {
    "heading": "关于配置包-about-the-configuration-package",
    "content": "@repo/eslint-config 软件包有三个配置文件：base.js、next.js 和 react-internal.js。它们之所以被称为 从 package.json 导出，是为了根据需要供其他软件包使用。配置示例可以在 在 Turborepo GitHub 仓库中 中找到，也可以在 npx create-turbo@latest 中找到。"
  }, {
    "heading": "关于配置包-about-the-configuration-package",
    "content": "¥The @repo/eslint-config package has three configuration files, base.js, next.js, and react-internal.js. They are exported from package.json so that they can be used by other packages, according to needs. Examples of the configurations can be found in the Turborepo GitHub repository and are available in npx create-turbo@latest."
  }, {
    "heading": "关于配置包-about-the-configuration-package",
    "content": "需要注意的是，next.js 和 react-internal.js 配置使用 base.js 配置以确保一致性，并根据各自的需求对其进行了扩展，添加了更多配置。此外，请注意，eslint-config 的 package.json 拥有存储库的所有 ESLint 依赖。这很有用，因为这意味着我们不需要在导入 @repo/eslint-config 的包中重新指定依赖。"
  }, {
    "heading": "关于配置包-about-the-configuration-package",
    "content": "¥Notably, the next.js and react-internal.js configurations use the base.js configuration for consistency, extending it with more configuration for their respective requirements. Additionally, notice that the package.json for eslint-config has all of the ESLint dependencies for the repository. This is useful, since it means we don't need to re-specify the dependencies in the packages that import @repo/eslint-config."
  }, {
    "heading": "使用配置包-using-the-configuration-package",
    "content": "¥Using the configuration package"
  }, {
    "heading": "使用配置包-using-the-configuration-package",
    "content": "在我们的 web 应用中，我们首先需要添加 @repo/eslint-config 作为依赖。"
  }, {
    "heading": "使用配置包-using-the-configuration-package",
    "content": "¥In our web app, we first need to add @repo/eslint-config as a dependency."
  }, {
    "heading": "使用配置包-using-the-configuration-package",
    "content": "然后我们可以像这样导入配置："
  }, {
    "heading": "使用配置包-using-the-configuration-package",
    "content": "¥We can then import the configuration like this:"
  }, {
    "heading": "使用配置包-using-the-configuration-package",
    "content": "此外，你可以像这样添加特定于包的配置："
  }, {
    "heading": "使用配置包-using-the-configuration-package",
    "content": "¥Additionally, you can add configuration specific to the package like this:"
  }, {
    "heading": "eslint-v8旧版-eslint-v8-legacy",
    "content": "¥ESLint v8 (Legacy)"
  }, {
    "heading": "eslint-v8旧版-eslint-v8-legacy",
    "content": "ESLint v8 将于 2024 年 10 月 5 日停止支持。我们建议你升级到 ESLint v9 或更高版本。此文档旨在帮助尚未升级的现有项目。"
  }, {
    "heading": "eslint-v8旧版-eslint-v8-legacy",
    "content": "¥ESLint v8 is end-of-life as of October 5, 2024. We encourage you to upgrade to\nESLint v9 or later. This documentation is here to help with existing projects\nthat have not yet upgraded."
  }, {
    "heading": "eslint-v8旧版-eslint-v8-legacy",
    "content": "使用 ESLint v8 及更低版本的旧配置，我们最终将得到如下文件结构："
  }, {
    "heading": "eslint-v8旧版-eslint-v8-legacy",
    "content": "¥Using legacy configuration from ESLint v8 and lower, we will end up with a file structure like this:"
  }, {
    "heading": "eslint-v8旧版-eslint-v8-legacy",
    "content": "有一个名为 @repo/eslint-config 的包，以及两个应用，每个应用都有自己的 .eslintrc.js。"
  }, {
    "heading": "eslint-v8旧版-eslint-v8-legacy",
    "content": "¥There's a package called @repo/eslint-config, and two applications, each with their own .eslintrc.js."
  }, {
    "heading": "repoeslint-config-软件包-the-repoeslint-config-package",
    "content": "¥The @repo/eslint-config package"
  }, {
    "heading": "repoeslint-config-软件包-the-repoeslint-config-package",
    "content": "@repo/eslint-config 文件包含两个文件：next.js 和 library.js。这是两种不同的 ESLint 配置，我们可以根据需要在不同的包中使用它们。"
  }, {
    "heading": "repoeslint-config-软件包-the-repoeslint-config-package",
    "content": "¥The @repo/eslint-config file contains two files, next.js, and library.js. These are two different ESLint configurations, which we can use in different packages, depending on our needs."
  }, {
    "heading": "repoeslint-config-软件包-the-repoeslint-config-package",
    "content": "Next.js 的配置可能如下所示："
  }, {
    "heading": "repoeslint-config-软件包-the-repoeslint-config-package",
    "content": "¥A configuration for Next.js may look like this:"
  }, {
    "heading": "repoeslint-config-软件包-the-repoeslint-config-package",
    "content": "package.json 如下所示："
  }, {
    "heading": "repoeslint-config-软件包-the-repoeslint-config-package",
    "content": "¥The package.json looks like this:"
  }, {
    "heading": "repoeslint-config-软件包-the-repoeslint-config-package",
    "content": "请注意，ESLint 依赖都列在这里。这很有用，因为这意味着我们不需要重新指定导入 @repo/eslint-config 的应用内的依赖。"
  }, {
    "heading": "repoeslint-config-软件包-the-repoeslint-config-package",
    "content": "¥Note that the ESLint dependencies are all listed here. This is useful, since it means we don't need to re-specify the dependencies inside the apps which import @repo/eslint-config."
  }, {
    "heading": "如何使用-repoeslint-config-软件包-how-to-use-the-repoeslint-config-package",
    "content": "¥How to use the @repo/eslint-config package"
  }, {
    "heading": "如何使用-repoeslint-config-软件包-how-to-use-the-repoeslint-config-package",
    "content": "在我们的 web 应用中，我们首先需要添加 @repo/eslint-config 作为依赖。"
  }, {
    "heading": "如何使用-repoeslint-config-软件包-how-to-use-the-repoeslint-config-package",
    "content": "¥In our web app, we first need to add @repo/eslint-config as a dependency."
  }, {
    "heading": "如何使用-repoeslint-config-软件包-how-to-use-the-repoeslint-config-package",
    "content": "然后我们可以像这样导入配置："
  }, {
    "heading": "如何使用-repoeslint-config-软件包-how-to-use-the-repoeslint-config-package",
    "content": "¥We can then import the config like this:"
  }, {
    "heading": "如何使用-repoeslint-config-软件包-how-to-use-the-repoeslint-config-package",
    "content": "通过将 @repo/eslint-config/next.js 添加到 extends 数组中，我们告诉 ESLint 查找名为 @repo/eslint-config 的包，并引用文件 next.js。"
  }, {
    "heading": "如何使用-repoeslint-config-软件包-how-to-use-the-repoeslint-config-package",
    "content": "¥By adding @repo/eslint-config/next.js to our extends array, we're telling ESLint to look for a package called @repo/eslint-config, and reference the file next.js."
  }, {
    "heading": "设置-lint-任务-setting-up-a-lint-task",
    "content": "¥Setting up a lint task"
  }, {
    "heading": "设置-lint-任务-setting-up-a-lint-task",
    "content": "每个你想要运行 ESLint 的包的 package.json 文件应如下所示："
  }, {
    "heading": "设置-lint-任务-setting-up-a-lint-task",
    "content": "¥The package.json for each package where you'd like to run ESLint should look like this:"
  }, {
    "heading": "设置-lint-任务-setting-up-a-lint-task",
    "content": "准备好脚本后，你可以创建 Turborepo 任务："
  }, {
    "heading": "设置-lint-任务-setting-up-a-lint-task",
    "content": "¥With your scripts prepared, you can then create your Turborepo task:"
  }, {
    "heading": "设置-lint-任务-setting-up-a-lint-task",
    "content": "你现在可以使用 全局 turbo 运行 turbo lint，或者在根目录 package.json 中创建脚本："
  }, {
    "heading": "设置-lint-任务-setting-up-a-lint-task",
    "content": "¥You can now run turbo lint with global turbo or create a script in your root package.json:"
  }],
  "headings": [{
    "id": "eslint-v9扁平配置-eslint-v9-flat-configs",
    "content": "ESLint v9（扁平配置） /*eslint-v9-flat-configs*/"
  }, {
    "id": "关于配置包-about-the-configuration-package",
    "content": "关于配置包 /*about-the-configuration-package*/"
  }, {
    "id": "使用配置包-using-the-configuration-package",
    "content": "使用配置包 /*using-the-configuration-package*/"
  }, {
    "id": "eslint-v8旧版-eslint-v8-legacy",
    "content": "ESLint v8（旧版） /*eslint-v8-legacy*/"
  }, {
    "id": "repoeslint-config-软件包-the-repoeslint-config-package",
    "content": "@repo/eslint-config 软件包 /*the-repoeslint-config-package*/"
  }, {
    "id": "如何使用-repoeslint-config-软件包-how-to-use-the-repoeslint-config-package",
    "content": "如何使用 @repo/eslint-config 软件包 /*how-to-use-the-repoeslint-config-package*/"
  }, {
    "id": "设置-lint-任务-setting-up-a-lint-task",
    "content": "设置 lint 任务 /*setting-up-a-lint-task*/"
  }]
};
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
import {Callout} from '#components/callout';
import {Files, Folder, File} from '#components/files';
import {CreateTurboCallout} from './create-turbo-callout.tsx';
export const toc = [{
  depth: 2,
  url: "#eslint-v9扁平配置-eslint-v9-flat-configs",
  title: _jsx(_Fragment, {
    children: "ESLint v9（扁平配置） "
  })
}, {
  depth: 3,
  url: "#关于配置包-about-the-configuration-package",
  title: _jsx(_Fragment, {
    children: "关于配置包 "
  })
}, {
  depth: 3,
  url: "#使用配置包-using-the-configuration-package",
  title: _jsx(_Fragment, {
    children: "使用配置包 "
  })
}, {
  depth: 2,
  url: "#eslint-v8旧版-eslint-v8-legacy",
  title: _jsx(_Fragment, {
    children: "ESLint v8（旧版） "
  })
}, {
  depth: 3,
  url: "#repoeslint-config-软件包-the-repoeslint-config-package",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "@repo/eslint-config"
    }), " 软件包 "]
  })
}, {
  depth: 3,
  url: "#如何使用-repoeslint-config-软件包-how-to-use-the-repoeslint-config-package",
  title: _jsxs(_Fragment, {
    children: ["如何使用 ", _jsx("code", {
      children: "@repo/eslint-config"
    }), " 软件包 "]
  })
}, {
  depth: 2,
  url: "#设置-lint-任务-setting-up-a-lint-task",
  title: _jsxs(_Fragment, {
    children: ["设置 ", _jsx("code", {
      children: "lint"
    }), " 任务 "]
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "ESLint 是一个静态分析工具，用于快速查找和修复 JavaScript 代码中的问题。"
    }), "\n", _jsx(_components.p, {
      children: "¥ESLint is a static analysis tool for quickly finding and fixing problems in your JavaScript code."
    }), "\n", _jsx(CreateTurboCallout, {}), "\n", _jsx(_components.p, {
      children: "在本指南中，我们将介绍："
    }), "\n", _jsx(_components.p, {
      children: "¥In this guide, we'll cover:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "#eslint-v9-flat-configs",
            children: "使用扁平配置的 ESLint v9"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "#eslint-v9-flat-configs",
            children: "ESLint v9 with Flat Configuration"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "#eslint-v8-legacy",
            children: "使用旧配置的 ESLint v8"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "#eslint-v8-legacy",
            children: "ESLint v8 with legacy configuration"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsxs(_components.a, {
            href: "#setting-up-a-lint-task",
            children: ["如何设置 ", _jsx(_components.code, {
              children: "lint"
            }), " 任务（适用于两个版本）"]
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsxs(_components.a, {
            href: "#setting-up-a-lint-task",
            children: ["How to set up a ", _jsx(_components.code, {
              children: "lint"
            }), " task (applies to both versions)"]
          })]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "我们将在 monorepo 的工作区内共享配置，确保配置在各个包之间保持一致且可组合，以保持较高的缓存命中率。"
    }), "\n", _jsx(_components.p, {
      children: "¥We will share configurations across the monorepo's Workspace, ensuring configuration is consistent across packages and composable to maintain high cache hit ratios."
    }), "\n", _jsx(_components.h2, {
      id: "eslint-v9扁平配置-eslint-v9-flat-configs",
      children: "ESLint v9（扁平配置） "
    }), "\n", _jsx(_components.p, {
      children: "¥ESLint v9 (Flat Configs)"
    }), "\n", _jsx(_components.p, {
      children: "使用 ESLint v9 的 Flat Configs，我们最终会得到如下文件结构："
    }), "\n", _jsx(_components.p, {
      children: "¥Using ESLint v9's Flat Configs, we will end up with a file structure like this:"
    }), "\n", _jsxs(Files, {
      children: [_jsxs(Folder, {
        name: "apps",
        defaultOpen: true,
        children: [_jsxs(Folder, {
          name: "docs",
          defaultOpen: true,
          children: [_jsx(File, {
            name: "package.json"
          }), _jsx(File, {
            name: "eslint.config.js",
            green: true
          })]
        }), _jsxs(Folder, {
          name: "web",
          defaultOpen: true,
          children: [_jsx(File, {
            name: "package.json"
          }), _jsx(File, {
            name: "eslint.config.js",
            green: true
          })]
        })]
      }), _jsxs(Folder, {
        name: "packages",
        defaultOpen: true,
        children: [_jsxs(Folder, {
          name: "eslint-config",
          defaultOpen: true,
          children: [_jsx(File, {
            name: "base.js",
            green: true
          }), _jsx(File, {
            name: "next.js",
            green: true
          }), _jsx(File, {
            name: "react-internal.js",
            green: true
          }), _jsx(File, {
            name: "package.json"
          })]
        }), _jsxs(Folder, {
          name: "ui",
          defaultOpen: true,
          children: [_jsx(File, {
            name: "eslint.config.js",
            green: true
          }), _jsx(File, {
            name: "package.json"
          })]
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "此结构包含："
    }), "\n", _jsx(_components.p, {
      children: "¥This structure includes:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "./packages/eslint-config"
          }), " 中名为 ", _jsx(_components.code, {
            children: "@repo/eslint-config"
          }), " 的包，其中包含所有 ESLint 配置"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥A package called ", _jsx(_components.code, {
            children: "@repo/eslint-config"
          }), " in ", _jsx(_components.code, {
            children: "./packages/eslint-config"
          }), " that holds all ESLint configuration"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["两个应用，每个都有自己的 ", _jsx(_components.code, {
            children: "eslint.config.js"
          })]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Two applications, each with their own ", _jsx(_components.code, {
            children: "eslint.config.js"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["一个 ", _jsx(_components.code, {
            children: "ui"
          }), " 包，它本身也包含 ", _jsx(_components.code, {
            children: "eslint.config.js"
          }), "。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥A ", _jsx(_components.code, {
            children: "ui"
          }), " package that also has its own ", _jsx(_components.code, {
            children: "eslint.config.js"
          })]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "关于配置包-about-the-configuration-package",
      children: "关于配置包 "
    }), "\n", _jsx(_components.p, {
      children: "¥About the configuration package"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "@repo/eslint-config"
      }), " 软件包有三个配置文件：", _jsx(_components.code, {
        children: "base.js"
      }), "、", _jsx(_components.code, {
        children: "next.js"
      }), " 和 ", _jsx(_components.code, {
        children: "react-internal.js"
      }), "。它们之所以被称为 ", _jsxs(_components.a, {
        href: "https://github.com/vercel/turborepo/blob/main/examples/basic/packages/eslint-config/package.json#L6",
        children: ["从 ", _jsx(_components.code, {
          children: "package.json"
        }), " 导出"]
      }), "，是为了根据需要供其他软件包使用。配置示例可以在 ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/tree/main/examples/basic/packages/eslint-config",
        children: "在 Turborepo GitHub 仓库中"
      }), " 中找到，也可以在 ", _jsx(_components.code, {
        children: "npx create-turbo@latest"
      }), " 中找到。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The ", _jsx(_components.code, {
        children: "@repo/eslint-config"
      }), " package has three configuration files, ", _jsx(_components.code, {
        children: "base.js"
      }), ", ", _jsx(_components.code, {
        children: "next.js"
      }), ", and ", _jsx(_components.code, {
        children: "react-internal.js"
      }), ". They are ", _jsxs(_components.a, {
        href: "https://github.com/vercel/turborepo/blob/main/examples/basic/packages/eslint-config/package.json#L6",
        children: ["exported from ", _jsx(_components.code, {
          children: "package.json"
        })]
      }), " so that they can be used by other packages, according to needs. Examples of the configurations can be found ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/tree/main/examples/basic/packages/eslint-config",
        children: "in the Turborepo GitHub repository"
      }), " and are available in ", _jsx(_components.code, {
        children: "npx create-turbo@latest"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["需要注意的是，", _jsx(_components.code, {
        children: "next.js"
      }), " 和 ", _jsx(_components.code, {
        children: "react-internal.js"
      }), " 配置使用 ", _jsx(_components.code, {
        children: "base.js"
      }), " 配置以确保一致性，并根据各自的需求对其进行了扩展，添加了更多配置。此外，请注意，", _jsxs(_components.a, {
        href: "https://github.com/vercel/turborepo/blob/main/examples/basic/packages/eslint-config/package.json",
        children: [_jsx(_components.code, {
          children: "eslint-config"
        }), " 的 ", _jsx(_components.code, {
          children: "package.json"
        })]
      }), " 拥有存储库的所有 ESLint 依赖。这很有用，因为这意味着我们不需要在导入 ", _jsx(_components.code, {
        children: "@repo/eslint-config"
      }), " 的包中重新指定依赖。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Notably, the ", _jsx(_components.code, {
        children: "next.js"
      }), " and ", _jsx(_components.code, {
        children: "react-internal.js"
      }), " configurations use the ", _jsx(_components.code, {
        children: "base.js"
      }), " configuration for consistency, extending it with more configuration for their respective requirements. Additionally, notice that ", _jsxs(_components.a, {
        href: "https://github.com/vercel/turborepo/blob/main/examples/basic/packages/eslint-config/package.json",
        children: ["the ", _jsx(_components.code, {
          children: "package.json"
        }), " for ", _jsx(_components.code, {
          children: "eslint-config"
        })]
      }), " has all of the ESLint dependencies for the repository. This is useful, since it means we don't need to re-specify the dependencies in the packages that import ", _jsx(_components.code, {
        children: "@repo/eslint-config"
      }), "."]
    }), "\n", _jsx(_components.h3, {
      id: "使用配置包-using-the-configuration-package",
      children: "使用配置包 "
    }), "\n", _jsx(_components.p, {
      children: "¥Using the configuration package"
    }), "\n", _jsxs(_components.p, {
      children: ["在我们的 ", _jsx(_components.code, {
        children: "web"
      }), " 应用中，我们首先需要添加 ", _jsx(_components.code, {
        children: "@repo/eslint-config"
      }), " 作为依赖。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥In our ", _jsx(_components.code, {
        children: "web"
      }), " app, we first need to add ", _jsx(_components.code, {
        children: "@repo/eslint-config"
      }), " as a dependency."]
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"devDependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"@repo/eslint-config\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"workspace:*\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"devDependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"@repo/eslint-config\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"*\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"devDependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"@repo/eslint-config\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"*\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"devDependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"@repo/eslint-config\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"workspace:*\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsx(_components.p, {
      children: "然后我们可以像这样导入配置："
    }), "\n", _jsx(_components.p, {
      children: "¥We can then import the configuration like this:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/eslint.config.js",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M0 0h24v24H0V0zm22.034 18.276c-.175-1.095-.888-2.015-3.003-2.873-.736-.345-1.554-.585-1.797-1.14-.091-.33-.105-.51-.046-.705.15-.646.915-.84 1.515-.66.39.12.75.42.976.9 1.034-.676 1.034-.676 1.755-1.125-.27-.42-.404-.601-.586-.78-.63-.705-1.469-1.065-2.834-1.034l-.705.089c-.676.165-1.32.525-1.71 1.005-1.14 1.291-.811 3.541.569 4.471 1.365 1.02 3.361 1.244 3.616 2.205.24 1.17-.87 1.545-1.966 1.41-.811-.18-1.26-.586-1.755-1.336l-1.83 1.051c.21.48.45.689.81 1.109 1.74 1.756 6.09 1.666 6.871-1.004.029-.09.24-.705.074-1.65l.046.067zm-8.983-7.245h-2.248c0 1.938-.009 3.864-.009 5.805 0 1.232.063 2.363-.138 2.711-.33.689-1.18.601-1.566.48-.396-.196-.597-.466-.83-.855-.063-.105-.11-.196-.127-.196l-1.825 1.125c.305.63.75 1.172 1.324 1.517.855.51 2.004.675 3.207.405.783-.226 1.458-.691 1.811-1.411.51-.93.402-2.07.397-3.346.012-2.054 0-4.109 0-6.179l.004-.056z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "import"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " { nextJsConfig } "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "from"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " '@repo/eslint-config/next-js'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ";"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "/** "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "@type"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " {import(\"eslint\").Linter.Config}"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: " */"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "export"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " default"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " nextJsConfig;"
            })]
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "此外，你可以像这样添加特定于包的配置："
    }), "\n", _jsx(_components.p, {
      children: "¥Additionally, you can add configuration specific to the package like this:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/eslint.config.js",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M0 0h24v24H0V0zm22.034 18.276c-.175-1.095-.888-2.015-3.003-2.873-.736-.345-1.554-.585-1.797-1.14-.091-.33-.105-.51-.046-.705.15-.646.915-.84 1.515-.66.39.12.75.42.976.9 1.034-.676 1.034-.676 1.755-1.125-.27-.42-.404-.601-.586-.78-.63-.705-1.469-1.065-2.834-1.034l-.705.089c-.676.165-1.32.525-1.71 1.005-1.14 1.291-.811 3.541.569 4.471 1.365 1.02 3.361 1.244 3.616 2.205.24 1.17-.87 1.545-1.966 1.41-.811-.18-1.26-.586-1.755-1.336l-1.83 1.051c.21.48.45.689.81 1.109 1.74 1.756 6.09 1.666 6.871-1.004.029-.09.24-.705.074-1.65l.046.067zm-8.983-7.245h-2.248c0 1.938-.009 3.864-.009 5.805 0 1.232.063 2.363-.138 2.711-.33.689-1.18.601-1.566.48-.396-.196-.597-.466-.83-.855-.063-.105-.11-.196-.127-.196l-1.825 1.125c.305.63.75 1.172 1.324 1.517.855.51 2.004.675 3.207.405.783-.226 1.458-.691 1.811-1.411.51-.93.402-2.07.397-3.346.012-2.054 0-4.109 0-6.179l.004-.056z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "import"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " { nextJsConfig } "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "from"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " '@repo/eslint-config/next-js'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ";"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "/** "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "@type"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " {import(\"eslint\").Linter.Config}"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: " */"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "export"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " default"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  ..."
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "nextJsConfig"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "  // Other configurations"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "];"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "eslint-v8旧版-eslint-v8-legacy",
      children: "ESLint v8（旧版） "
    }), "\n", _jsx(_components.p, {
      children: "¥ESLint v8 (Legacy)"
    }), "\n", _jsxs(Callout, {
      type: "warn",
      children: [_jsx(_components.p, {
        children: "ESLint v8 将于 2024 年 10 月 5 日停止支持。我们建议你升级到 ESLint v9 或更高版本。此文档旨在帮助尚未升级的现有项目。"
      }), _jsx(_components.p, {
        children: "¥ESLint v8 is end-of-life as of October 5, 2024. We encourage you to upgrade to\nESLint v9 or later. This documentation is here to help with existing projects\nthat have not yet upgraded."
      })]
    }), "\n", _jsx(_components.p, {
      children: "使用 ESLint v8 及更低版本的旧配置，我们最终将得到如下文件结构："
    }), "\n", _jsx(_components.p, {
      children: "¥Using legacy configuration from ESLint v8 and lower, we will end up with a file structure like this:"
    }), "\n", _jsxs(Files, {
      children: [_jsxs(Folder, {
        name: "apps",
        defaultOpen: true,
        children: [_jsxs(Folder, {
          name: "docs",
          defaultOpen: true,
          children: [_jsx(File, {
            name: "package.json"
          }), _jsx(File, {
            name: ".eslintrc.js",
            green: true
          })]
        }), _jsxs(Folder, {
          name: "web",
          defaultOpen: true,
          children: [_jsx(File, {
            name: "package.json"
          }), _jsx(File, {
            name: ".eslintrc.js",
            green: true
          })]
        })]
      }), _jsxs(Folder, {
        name: "packages",
        defaultOpen: true,
        children: [_jsxs(Folder, {
          name: "eslint-config",
          defaultOpen: true,
          children: [_jsx(File, {
            name: "base.js",
            green: true
          }), _jsx(File, {
            name: "next.js",
            green: true
          }), _jsx(File, {
            name: "react-internal.js",
            green: true
          }), _jsx(File, {
            name: "package.json"
          })]
        }), _jsxs(Folder, {
          name: "ui",
          defaultOpen: true,
          children: [_jsx(File, {
            name: ".eslintrc.js",
            green: true
          }), _jsx(File, {
            name: "package.json"
          })]
        })]
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["有一个名为 ", _jsx(_components.code, {
        children: "@repo/eslint-config"
      }), " 的包，以及两个应用，每个应用都有自己的 ", _jsx(_components.code, {
        children: ".eslintrc.js"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥There's a package called ", _jsx(_components.code, {
        children: "@repo/eslint-config"
      }), ", and two applications, each with their own ", _jsx(_components.code, {
        children: ".eslintrc.js"
      }), "."]
    }), "\n", _jsxs(_components.h3, {
      id: "repoeslint-config-软件包-the-repoeslint-config-package",
      children: [_jsx(_components.code, {
        children: "@repo/eslint-config"
      }), " 软件包 "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The ", _jsx(_components.code, {
        children: "@repo/eslint-config"
      }), " package"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "@repo/eslint-config"
      }), " 文件包含两个文件：", _jsx(_components.code, {
        children: "next.js"
      }), " 和 ", _jsx(_components.code, {
        children: "library.js"
      }), "。这是两种不同的 ESLint 配置，我们可以根据需要在不同的包中使用它们。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The ", _jsx(_components.code, {
        children: "@repo/eslint-config"
      }), " file contains two files, ", _jsx(_components.code, {
        children: "next.js"
      }), ", and ", _jsx(_components.code, {
        children: "library.js"
      }), ". These are two different ESLint configurations, which we can use in different packages, depending on our needs."]
    }), "\n", _jsx(_components.p, {
      children: "Next.js 的配置可能如下所示："
    }), "\n", _jsx(_components.p, {
      children: "¥A configuration for Next.js may look like this:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./packages/eslint-config/next.js",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M0 0h24v24H0V0zm22.034 18.276c-.175-1.095-.888-2.015-3.003-2.873-.736-.345-1.554-.585-1.797-1.14-.091-.33-.105-.51-.046-.705.15-.646.915-.84 1.515-.66.39.12.75.42.976.9 1.034-.676 1.034-.676 1.755-1.125-.27-.42-.404-.601-.586-.78-.63-.705-1.469-1.065-2.834-1.034l-.705.089c-.676.165-1.32.525-1.71 1.005-1.14 1.291-.811 3.541.569 4.471 1.365 1.02 3.361 1.244 3.616 2.205.24 1.17-.87 1.545-1.966 1.41-.811-.18-1.26-.586-1.755-1.336l-1.83 1.051c.21.48.45.689.81 1.109 1.74 1.756 6.09 1.666 6.871-1.004.029-.09.24-.705.074-1.65l.046.067zm-8.983-7.245h-2.248c0 1.938-.009 3.864-.009 5.805 0 1.232.063 2.363-.138 2.711-.33.689-1.18.601-1.566.48-.396-.196-.597-.466-.83-.855-.063-.105-.11-.196-.127-.196l-1.825 1.125c.305.63.75 1.172 1.324 1.517.855.51 2.004.675 3.207.405.783-.226 1.458-.691 1.811-1.411.51-.93.402-2.07.397-3.346.012-2.054 0-4.109 0-6.179l.004-.056z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "/* Custom ESLint configuration for use with Next.js apps. */"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "module"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "."
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "exports"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " ="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  extends"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "    'eslint-config-turbo'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "    'eslint-config-next'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "    // ...your other ESLint configurations"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  ]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: ".map"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "("
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "require"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ".resolve)"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "  // ...your other configuration"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "};"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "package.json"
      }), " 如下所示："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The ", _jsx(_components.code, {
        children: "package.json"
      }), " looks like this:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./packages/eslint-config/package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"name\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"@repo/eslint-config\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"version\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"0.0.0\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"private\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"devDependencies\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"eslint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"^8\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"eslint-config-turbo\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"latest\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"eslint-config-next\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"latest\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["请注意，ESLint 依赖都列在这里。这很有用，因为这意味着我们不需要重新指定导入 ", _jsx(_components.code, {
        children: "@repo/eslint-config"
      }), " 的应用内的依赖。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Note that the ESLint dependencies are all listed here. This is useful, since it means we don't need to re-specify the dependencies inside the apps which import ", _jsx(_components.code, {
        children: "@repo/eslint-config"
      }), "."]
    }), "\n", _jsxs(_components.h3, {
      id: "如何使用-repoeslint-config-软件包-how-to-use-the-repoeslint-config-package",
      children: ["如何使用 ", _jsx(_components.code, {
        children: "@repo/eslint-config"
      }), " 软件包 "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥How to use the ", _jsx(_components.code, {
        children: "@repo/eslint-config"
      }), " package"]
    }), "\n", _jsxs(_components.p, {
      children: ["在我们的 ", _jsx(_components.code, {
        children: "web"
      }), " 应用中，我们首先需要添加 ", _jsx(_components.code, {
        children: "@repo/eslint-config"
      }), " 作为依赖。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥In our ", _jsx(_components.code, {
        children: "web"
      }), " app, we first need to add ", _jsx(_components.code, {
        children: "@repo/eslint-config"
      }), " as a dependency."]
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"dependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"@repo/eslint-config\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"workspace:*\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"dependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"@repo/eslint-config\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"*\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"dependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"@repo/eslint-config\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"*\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"dependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"@repo/eslint-config\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"workspace:*\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsx(_components.p, {
      children: "然后我们可以像这样导入配置："
    }), "\n", _jsx(_components.p, {
      children: "¥We can then import the config like this:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/.eslintrc.js",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M0 0h24v24H0V0zm22.034 18.276c-.175-1.095-.888-2.015-3.003-2.873-.736-.345-1.554-.585-1.797-1.14-.091-.33-.105-.51-.046-.705.15-.646.915-.84 1.515-.66.39.12.75.42.976.9 1.034-.676 1.034-.676 1.755-1.125-.27-.42-.404-.601-.586-.78-.63-.705-1.469-1.065-2.834-1.034l-.705.089c-.676.165-1.32.525-1.71 1.005-1.14 1.291-.811 3.541.569 4.471 1.365 1.02 3.361 1.244 3.616 2.205.24 1.17-.87 1.545-1.966 1.41-.811-.18-1.26-.586-1.755-1.336l-1.83 1.051c.21.48.45.689.81 1.109 1.74 1.756 6.09 1.666 6.871-1.004.029-.09.24-.705.074-1.65l.046.067zm-8.983-7.245h-2.248c0 1.938-.009 3.864-.009 5.805 0 1.232.063 2.363-.138 2.711-.33.689-1.18.601-1.566.48-.396-.196-.597-.466-.83-.855-.063-.105-.11-.196-.127-.196l-1.825 1.125c.305.63.75 1.172 1.324 1.517.855.51 2.004.675 3.207.405.783-.226 1.458-.691 1.811-1.411.51-.93.402-2.07.397-3.346.012-2.054 0-4.109 0-6.179l.004-.056z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "module"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "."
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "exports"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " ="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  root"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  extends"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "'@repo/eslint-config/next.js'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "};"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["通过将 ", _jsx(_components.code, {
        children: "@repo/eslint-config/next.js"
      }), " 添加到 ", _jsx(_components.code, {
        children: "extends"
      }), " 数组中，我们告诉 ESLint 查找名为 ", _jsx(_components.code, {
        children: "@repo/eslint-config"
      }), " 的包，并引用文件 ", _jsx(_components.code, {
        children: "next.js"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥By adding ", _jsx(_components.code, {
        children: "@repo/eslint-config/next.js"
      }), " to our ", _jsx(_components.code, {
        children: "extends"
      }), " array, we're telling ESLint to look for a package called ", _jsx(_components.code, {
        children: "@repo/eslint-config"
      }), ", and reference the file ", _jsx(_components.code, {
        children: "next.js"
      }), "."]
    }), "\n", _jsxs(_components.h2, {
      id: "设置-lint-任务-setting-up-a-lint-task",
      children: ["设置 ", _jsx(_components.code, {
        children: "lint"
      }), " 任务 "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Setting up a ", _jsx(_components.code, {
        children: "lint"
      }), " task"]
    }), "\n", _jsxs(_components.p, {
      children: ["每个你想要运行 ESLint 的包的 ", _jsx(_components.code, {
        children: "package.json"
      }), " 文件应如下所示："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The ", _jsx(_components.code, {
        children: "package.json"
      }), " for each package where you'd like to run ESLint should look like this:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./packages/*/package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"eslint .\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "准备好脚本后，你可以创建 Turborepo 任务："
    }), "\n", _jsx(_components.p, {
      children: "¥With your scripts prepared, you can then create your Turborepo task:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "    \"lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " {}"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["你现在可以使用 ", _jsxs(_components.a, {
        href: "/docs/getting-started/installation#global-installation",
        children: ["全局 ", _jsx(_components.code, {
          children: "turbo"
        })]
      }), " 运行 ", _jsx(_components.code, {
        children: "turbo lint"
      }), "，或者在根目录 ", _jsx(_components.code, {
        children: "package.json"
      }), " 中创建脚本："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You can now run ", _jsx(_components.code, {
        children: "turbo lint"
      }), " with ", _jsxs(_components.a, {
        href: "/docs/getting-started/installation#global-installation",
        children: ["global ", _jsx(_components.code, {
          children: "turbo"
        })]
      }), " or create a script in your root ", _jsx(_components.code, {
        children: "package.json"
      }), ":"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"turbo run lint\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
